import { useState } from "react";
import { toast } from "sonner";
import { FileDown, Loader2 } from "lucide-react";
import { downloadFile, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Checkbox } from "@/components/ui/checkbox";

const SECTIONS = [["helpers", "My top helpers"], ["ingredients", "Good-day ingredients"], ["warnings", "Early signs"], ["own", "Helpers in my own words"], ["quotes", "Things I said helped"]];

export const PlaybookPdfButton = () => {
  const [open, setOpen] = useState(false);
  const [picked, setPicked] = useState(() => new Set(SECTIONS.map(([k]) => k)));
  const [busy, setBusy] = useState(false);
  const toggle = (k) => setPicked((s) => { const n = new Set(s); n.has(k) ? n.delete(k) : n.add(k); return n; });
  const save = async () => {
    setBusy(true);
    try { await downloadFile(`/playbook/pdf?sections=${SECTIONS.map(([k]) => k).filter((k) => picked.has(k)).join(",")}`, "what-helps-me.pdf"); toast.success("PDF downloaded"); setOpen(false); }
    catch (e) { toast.error(errMsg(e, "Could not make the PDF")); } finally { setBusy(false); }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} className="mm-btn-ghost" data-testid="playbook-pdf-open"><FileDown size={16} />Save as PDF</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="playbook-pdf-dialog">
          <DialogHeader><DialogTitle>Save your playbook as a PDF</DialogTitle></DialogHeader>
          <p className="text-sm text-mm-muted">Handy for a therapist or just for you. Pick what to include.</p>
          <div className="space-y-3 mt-2">
            {SECTIONS.map(([k, l]) => (
              <label key={k} className="flex items-center gap-3 text-sm cursor-pointer"><Checkbox checked={picked.has(k)} onCheckedChange={() => toggle(k)} data-testid={`playbook-pdf-${k}`} />{l}</label>
            ))}
          </div>
          <button className="mm-btn w-full mt-4" disabled={busy || !picked.size} onClick={save} data-testid="playbook-pdf-download">{busy && <Loader2 size={16} className="animate-spin" />}Download PDF</button>
        </DialogContent>
      </Dialog>
    </>
  );
};
